﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { ICadLayerField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadLayerField, eOutputFieldType.cadLayer)
export class CadLayerField extends OutputField implements ICadLayerField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public layerName: string;
    public lineType: string;
    public toAdd: boolean;
    public active: boolean;
    public freeze: boolean;
    public lineWeight: string; // eLayerLineWeight
    public color: string;
    public lock: boolean;
    public plottable: boolean;
}
